// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ProcessIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ProcessIcon" ref={forwardedRef} {...props}>
      <path d="M15 2a1 1 0 0 1 1 1v1.5a1 1 0 0 1-1 1h-4v2h4a1 1 0 0 1 1 1v2.25a1 1 0 0 1-1 1h-4v2h4a1 1 0 0 1 1 1V17a1 1 0 0 1-1 1H5a1 1 0 0 1-.995-.898L4 17v-2.25l.005-.102a1 1 0 0 1 .892-.893L5 13.75h4v-2H5a1 1 0 0 1-.995-.898L4 10.75V8.5l.005-.103a1 1 0 0 1 .892-.892L5 7.5h4v-2H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zM5.5 16.5h9v-1.25h-9zm0-6.25h9V9h-9z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ProcessIcon = /* @__PURE__ */ Object.assign(ProcessIconComponent, {
  displayName: 'ProcessIcon',
});
